import { createBrowserHistory } from 'history';
import configs from '../configs';

export const history = createBrowserHistory({
  basename: configs.publicUrl,
});
